// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullRegattaPayment,
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  RegattaPaymentStatus,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';

// Helpers
import _ from 'lodash';
import {
  regattaPaymentStatusLabel,
} from 'common.language';

// Types
type $Props = $Translate & {
  item: $FullRegattaPayment | $Model<'RegattaPayment'> | $ModelUpsertParams<'RegattaPayment'>;
};

const RegattaPaymentFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <Row>
      <Col>
        <AvField
          label={t('Status')}
          name={'Status'}
          required
          type={'select'}
          value={item.Status}
        >
          {_.map(
            RegattaPaymentStatus,
            (i) => (
              <option
                key={i}
                value={i}
              >
                {t(regattaPaymentStatusLabel[i])}
              </option>
            ),
          )}
        </AvField>
      </Col>
    </Row>
  );
};

export default RegattaPaymentFieldsView;
